<template>
   <div class="MilestoneLessonList container-fluid bottom-dotted-border margin-Top-Bottom-1Point5Perc"> 
        <div class="admin-Panel-Padding">
            <div class="row vertical-align">
             <div class="col-md-1 col-lg-1">
             </div>
             <div class="col-md-1 col-lg-1">
               <input type="checkbox" value="true" v-model="getIsSelectedLessonValue" :disabled="disableCheckBox">
             </div>
             <div class="col-md-10 col-lg-10">
                 <div class="row">
                     <div class="col-md-3 col-lg-3 text-align-left lesson-index-text-size">
                         {{getLessonNumber}}<span>{{getModuleDuration}}</span>
                     </div>
                      <div class="col-md-9 col-lg-9 cursor-default">
                        <div class="row vertical-align padding-0perc text-align-left lesson-index-text-size">
                          <div class="tooltip1 margin-right-2px">
                            <img :src="getIsOptionalSrcValue" class="img-responsive icon-width-height-content-locked-bonus align-center margin-0Perc" alt="isOptional">
                            <span class="tooltiptext1">{{getIsOptionalTooltipValue}}</span>
                          </div>
                          <div class="tooltip1 margin-right-2px">
                            <img :src="getIsUnlockedSrcValue" class="img-responsive icon-width-height-content-locked-bonus align-center" alt="isUnlocked">
                            <span class="tooltiptext1">{{getIsUnlockedTooltipValue}}</span>  
                          </div>
                          <span class="text-align-left tooltip1 margin-left-5px margin-right-2px">{{getHumanReadableDate(getLessonObject.ReleaseDate)}}</span>
                        </div>
                      </div>
                 </div>
                 <div class="row padding-top-2px">
                     <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 text-align-left lesson-name-text-size lesson-name-style">
                         {{getLessonObject.Title}}
                     </div>
                 </div>        
             </div>
             <div class="col-md-1 col-lg-1">
             </div>    
            </div>
        </div>
        <milestone-element-list v-for="eleObj in getElementList" :key="eleObj.ElementId" v-bind:elementObj="eleObj" v-bind:elementList="getElementList" v-bind:courseJourneyList="getCourseJourneyList" v-bind:lessonObj="getLessonObject"></milestone-element-list>
        <!-- Show Spinner -->
        <div class="animationload" v-show="showSpinner">
            <div class="osahanloading"></div>
        </div>
        <!-- <loader></loader> -->
        <alert-box v-if="showAlertDialog" v-bind:errorMsg="errorMsg" @showAlertBox="updateShowAlertDialogFlag"></alert-box>  
    </div>    
</template>
<script>
import { constants } from '@/utils/constants'
import { dmAdminUtils } from '@/utils/dmAdminUtils'
import Loader from '@/components/dashboard/Loader'
import AlertBox from '@/components/AlertOverlay'
import lockicon from '../assets/images/lock.svg'
import unlockicon from '../assets/images/unlock.svg'
import optionalicon from '../assets/images/optional.svg'
import compulsoryicon from '../assets/images/compulsory.svg'
import MilestoneElementList from '@/components/MilestoneElementList'
// import remove from 'lodash/remove'
import forEach from 'lodash/forEach'
import indexOf from 'lodash/indexOf'
import filter from 'lodash/filter'
import map from 'lodash/map'
import flatten from 'lodash/flatten'
import size from 'lodash/size'
export default {
  props: ['currLessonObj', 'courseJourneyList'],
  created: function () {
    this.checkAndSetIsLessonSelected()
    this.checkAndSetDisableCheckBoxFlag()
  },
  data: function () {
    return {
      showAlertDialog: false,
      errorMsg: '',
      showSpinner: false,
      isLessonSelected: false,
      disableCheckBox: false
    }
  },
  name: 'MilestoneLessonList',
  methods: {
    checkAndSetDisableCheckBoxFlag: function () {
      if (this.getElementList.length === 0) {
        this.disableCheckBox = true
      } else {
        this.disableCheckBox = false
      }
    },
    getHumanReadableDate (date) {
      return dmAdminUtils.getHumanReadableEST(date + 'Z')
    },
    updateShowAlertDialogFlag (value) {
      this.showAlertDialog = value
    },
    updateShowConfirmationAlertFlag (value) {
      // AK: Used when user pressed close button of confirmation overlay
      this.showConfirmationBox = value
    },
    addOrRemoveElementIdsFromList: function () {
      var _this = this
      if (this.getIsSelectedLessonValue) {
        forEach(this.getElementList, function (elementObj) {
          // AK: If current element type is Bonus then do add remaining/left/all in the list
          if (elementObj.Type === 7) {
            forEach(elementObj.BonusElements, function (bonusElementObj) {
              var indexNo = indexOf(_this.$store.state.elementIdsToComplete, bonusElementObj.ElementId)
              if (indexNo === -1) {
                _this.$store.state.elementIdsToComplete.push(bonusElementObj.ElementId)
              }
            })
          } else {
            var indexNo = indexOf(_this.$store.state.elementIdsToComplete, elementObj.ElementId)
            if (indexNo === -1) {
              // AK: Add the current module's all the element only if they are not present in list already.
              _this.$store.state.elementIdsToComplete.push(elementObj.ElementId)
            } else {
              // console.log('Already removed from list')
            }
          }
        })
        console.log('Adding all Normal and Bonus Steps: ' + this.$store.state.elementIdsToComplete.length)
      } else {
        forEach(this.getElementList, function (elementObj) {
          var indexNo = indexOf(_this.$store.state.elementIdsToComplete, elementObj.ElementId)
          if (indexNo > -1) {
            // AK: Remove the current element from the list only if it's already present
            _this.$store.state.elementIdsToComplete.splice(indexNo, 1)
          } else {
            // console.log('Already removed from list')
          }
          // AK: If current element type is Bonus then do remove all available bonus elements from list
          if (elementObj.Type === 7) {
            forEach(elementObj.BonusElements, function (bonusElementObj) {
              var bonusIndexNo = indexOf(_this.$store.state.elementIdsToComplete, bonusElementObj.ElementId)
              if (bonusIndexNo > -1) {
                // AK: Remove the current element from the list only if it's already present
                _this.$store.state.elementIdsToComplete.splice(bonusIndexNo, 1)
              } else {
                // console.log('Already removed from list')
              }
            })
          }
        })
        console.log('Removing all Normal and Bonus Steps: ' + this.$store.state.elementIdsToComplete.length)
      }
    },
    checkAndSetIsLessonSelected: function () {
      var _this = this
      const elementsCount = size(this.getLessonObject.Elements)
      const bonusElements = filter(this.getLessonObject.Elements, {Type: 7})
      const bonusElementsChildren = flatten(map(bonusElements, 'BonusElements'))
      const totalElementCountInCurrentLesson = elementsCount + size(bonusElementsChildren) - size(bonusElements)
      // console.log(this.getLessonObject.Title + ' ### totalElementCountInCurrentLesson:', totalElementCountInCurrentLesson)
      var totalSelectedElementCountFromList = 0
      forEach(this.getElementList, function (currElementObj) {
        if (currElementObj.Type === 7) {
          const bonusElementObjCount = currElementObj.BonusElements.length
          if (bonusElementObjCount > 0) {
            forEach(currElementObj.BonusElements, function (currBonusElementObj) {
              const foundIndex = indexOf(_this.$store.state.elementIdsToComplete, currBonusElementObj.ElementId)
              if (foundIndex > -1) {
                totalSelectedElementCountFromList += 1
              }
            })
          }
        } else {
          const foundIndex = indexOf(_this.$store.state.elementIdsToComplete, currElementObj.ElementId)
          if (foundIndex > -1) {
            totalSelectedElementCountFromList += 1
          }
        }
      })
      // console.log(this.getLessonObject.Title + '### totalSelectedElementCountFromList:' + totalSelectedElementCountFromList)
      if (totalElementCountInCurrentLesson === totalSelectedElementCountFromList) {
        this.isLessonSelected = true
      } else {
        this.isLessonSelected = false
      }
    }
  },
  components: {
    'alert-box': AlertBox,
    'loader': Loader,
    'milestone-element-list': MilestoneElementList
  },
  computed: {
    getElementIdsToComplete: {
      get: function () {
        return this.$store.state.elementIdsToComplete
      }
    },
    getCourseJourneyList: {
      get: function () {
        return this.courseJourneyList
      }
    },
    getIsSelectedLessonValue: {
      get: function () {
        return this.isLessonSelected
      },
      set: function (newValue) {
        this.isLessonSelected = newValue
        this.addOrRemoveElementIdsFromList()
      }
    },
    getLessonNumber: {
      get: function () {
        if (this.isBonusModule) {
          return 'Bonus Content'
        } else {
          var valueToReturn = ''
          switch (this.getLessonNumberingValue) {
            default:
            case constants.LessonNumberingType.Default:
              valueToReturn = 'Lesson ' + this.getLessonObject.DisplayIndex
              break
            case constants.LessonNumberingType.Custom:
              valueToReturn = this.getLessonObject.LessonNumberText !== null && this.getLessonObject.LessonNumberText !== undefined ? this.getLessonObject.LessonNumberText : 'Data Missing'
              break
            case constants.LessonNumberingType.Hide:
              valueToReturn = 'NA'
              break
          }
          return valueToReturn
        }
      }
    },
    isBonusModule: {
      get: function () {
        return this.getLessonObject.IsBonusContent
      }
    },
    getLessonObject: {
      get: function () {
        return this.currLessonObj
      }
    },
    getModuleDuration: {
      get: function () {
        var durationToReturn = this.getLessonObject.Duration !== undefined && this.getLessonObject.Duration !== '' && this.getLessonObject.Duration !== null && this.getLessonObject.Duration !== 'null' ? ' / ' + this.getLessonObject.Duration : ''
        return durationToReturn
      }
    },
    getIsOptionalSrcValue: {
      get: function () {
        this.isOptionalSrc = this.getLessonObject.IsOptional ? optionalicon : compulsoryicon
        return this.isOptionalSrc
      }
    },
    getIsOptionalTooltipValue: {
      get: function () {
        this.isOptionalTooltip = this.getLessonObject.IsOptional ? constants.Is_Optional_True_Tooltip_Text : constants.Is_Optional_False_Tooltip_Text
        return this.isOptionalTooltip
      }
    },
    getIsUnlockedSrcValue: {
      get: function () {
        this.isUnlockedSrc = this.getLessonObject.IsUnlocked ? unlockicon : lockicon
        return this.isUnlockedSrc
      }
    },
    getIsUnlockedTooltipValue: {
      get: function () {
        this.isUnlockedTooltip = this.getLessonObject.IsUnlocked ? constants.Is_Unlocked_True_Tooltip_Text : constants.Is_Unlocked_False_Tooltip_Text
        return this.isUnlockedTooltip
      }
    },
    getElementList: {
      get: function () {
        return this.getLessonObject.Elements
      }
    }
  },
  watch: {
    getIsSelectedLessonValue: function (newValue, oldValue) {},
    getElementIdsToComplete: function (newValue, oldValue) {
      this.checkAndSetIsLessonSelected()
    }
  }
}
</script> 
<style scoped>
.animationload {
  height: 100%;
  left: 0;
  position: fixed;
  top: 0;
  width: 100%;
  z-index: 10000;
}
.osahanloading {
  animation: 1.5s linear 0s normal none infinite running osahanloading;
  background: #fed37f none repeat scroll 0 0;
  border-radius: 50px;
  height: 50px;
  left: 50%;
  margin-left: -25px;
  margin-top: -25px;
  position: absolute;
  top: 50%;
  width: 50px;
}
.osahanloading::after {
  animation: 1.5s linear 0s normal none infinite running osahanloading_after;
  border-color: #85d6de transparent;
  border-radius: 80px;
  border-style: solid;
  border-width: 10px;
  content: "";
  height: 80px;
  left: -15px;
  position: absolute;
  top: -15px;
  width: 80px;
}
@keyframes osahanloading {
  0% {
    transform: rotate(0deg);
  }
  50% {
    background: #85d6de none repeat scroll 0 0;
    transform: rotate(180deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
.opacity-point-2 {
  opacity: 0.5;
}
.cursor-pointer {
  cursor: pointer;
}
.lesson-list {
  width: 100%;
}
.lesson-name-style {
  font-weight: bold;
}
.bottom-dotted-border {
  border-bottom: 1px dotted #aaa;
}
.arrow-right {
  width: 0;
  height: 0;
  border-top: 10px solid transparent;
  border-bottom: 10px solid transparent;
  border-left: 10px solid #34495e;
  cursor: pointer;
}
.arrow-down {
  width: 0;
  height: 0;
  border-left: 10px solid transparent;
  border-right: 10px solid transparent;
  border-top: 10px solid #34495e;
  cursor: pointer;
}
.vertical-align {
  display: flex;
  align-items: center;
}
.margin-Top-Bottom-1Point5Perc {
  padding-top: 1.5%;
  padding-bottom: 1.5%;
}
.icon-width-height {
  width: 24px;
  height: 29px;
}
.icon-width-height-content-locked-bonus {
  width: 21px;
  height: 21px;
}
.red-color-border {
  border: 1px solid red;
}
.green-color-border {
  border: 1px solid green;
}
.align-center {
  margin: 0 auto !important;
}
.text-align-left {
  text-align: left;
}
.lesson-name-text-size {
  font-size: 17px;
}
.lesson-index-text-size {
  font-size: 14px;
}
.border-red {
  border: 1px solid red;
}
.tooltip1 {
    position: relative;
    display: inline-block;
}
.tooltip1 .tooltiptext1 {
    visibility: hidden;
    /* width: 133px; */
    width: -webkit-fill-available;
    background-color: #696969;
    color: #fff;
    text-align: center;
    border-radius: 6px;
    padding: 5px 1px;
    position: absolute;
    z-index: 1;
    top: 130%;
    left: 140%;
    margin-left: -50px;
    font-size:12px;
  }

.tooltip1 .tooltiptext1::after {
    content: "";
    position: absolute;
    bottom: 100%;
    left: 50%;
    margin-left: -5px;
    border-width: 5px;
    border-style: solid;
    border-color: transparent transparent #696969 transparent;
}
.tooltip1:hover .tooltiptext1 {
    visibility: visible;
}
.padding-0perc {
  padding:0%;
}
.margin-0Perc {
  margin: 0%;
}
.cursor-default {
  cursor: default;
}
.padding-left-0perc {
  padding-left:0%;
}
.padding-top-2px {
  padding-top:2px;
}
.margin-right-2px {
  margin-right:2px;
}
.margin-left-5px {
  margin-left:5px;
}
</style>



// WEBPACK FOOTER //
// src/components/MilestoneLessonList.vue